// extracted by mini-css-extract-plugin
module.exports = {"inputs":"_1556195","inputWrapper":"_5c5d021"};